/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

function PlusIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M2 8L14 8" stroke="currentColor" strokeLinecap="round" />
      <path d="M8 2V14" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export default PlusIcon;
